var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DepartmentUserForm',{attrs:{"userId":_vm.userId,"departmentId":_vm.departmentId}})
}
var staticRenderFns = []

export { render, staticRenderFns }